import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TripService } from 'src/app/services/trip/trip.service';

@Component({
  selector: 'app-trip',
  templateUrl: './trip.component.html',
  styleUrls: ['./trip.component.scss']
})
export class TripComponent implements OnInit {
  selectedVal: string
  mapView: boolean = false;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  constructor(
    public dialog: MatDialog,
    public tripService: TripService
  ) { }

  ngOnInit() {
    this.selectedVal ='1week';
  }

  ngAfterViewInit() {
   
  }
  toogleView() {
    if (!this.mapView) {
      this.mapView = true;
      console.log(this.mapView);
    } else {
      this.mapView = false
      console.log(this.mapView);
    }
  }

  onValChange() {
    this.notifyParent.emit('e');
  }
}

